import "../styles/HamburgerMenu.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faCircleUser, faFolder, faXmark } from "@fortawesome/free-solid-svg-icons";


const HamburgerMenu = ({isOpenMenu,setOpenMenu}:any) => {

    return (
        <nav className={`menu-mobile ${isOpenMenu ? 'active' : ''}`}>
                <a href="/"><FontAwesomeIcon icon={faHome}></FontAwesomeIcon> Inicio</a>
                <a href="/about"><FontAwesomeIcon icon={faCircleUser}></FontAwesomeIcon> Acerca de</a>
                <a href="/projects"><FontAwesomeIcon icon={faFolder}></FontAwesomeIcon> Proyectos</a>
                <a className="btn-cancel" onClick={setOpenMenu}><FontAwesomeIcon icon={faXmark}></FontAwesomeIcon></a>
        </nav>
    );
}

export default HamburgerMenu;